import clsx from 'clsx';
import { Floor } from 'lib/types';
import Status from '../status';
import PriceDynamics from 'components/price-dynamics';
import { toReadablePrice, toReadableSquarePrice, formatApartmentDesc } from 'lib/utils';
import IconButton from '../icon-button';
import eyeSlash from '../../assets/images/eye-slash.svg';
import iconBuildingDefault from '../../assets/images/building-default.png';
import styles from './styles.module.scss';
import { MarketTypes } from 'api/types';

export type ApartmentListItemProps = {
  className?: string;
  housingEstate: string;
  image?: string;
  attachment?: string;
  price?: number;
  squarePrice?: number;
  area: number;
  rooms: number | null;
  floor: Floor;
  isFavorite?: boolean;
  isSavedInTemporaryFiles?: boolean;
  notificationEnabled?: boolean;
  icon?: React.ReactNode;
  leftIcon?: React.ReactNode;
  centreIcon?: React.ReactNode;
  priceDirection?: 'up' | 'down';
  onClick?: () => void;
  hiddenUntil?: boolean;
  status?: { key: string; translation: string };
  marketType?: string;
  buildingTitle: string;
  isShowBuildingHouse?: boolean;
  isSecondaryMode?: boolean;
};

const ApartmentListItem: React.FC<any> = (props) => {
  const {
    className,
    housingEstate,
    image,
    price,
    squarePrice,
    area,
    rooms,
    floor,
    icon,
    priceDirection,
    onClick,
    leftIcon,
    centreIcon,
    isHide,
    status,
    buildingTitle,
    apartmentComplexesTitle,
    planImage,
    attachment,
    isShowBuildingHouse = false,
    marketType,
  } = props;

  const sumArea = Array.isArray(area)
    ? area.reduce((acc: any, currentValue: any) => acc + currentValue, 0)
    : 0;

  const isSecondaryMode = marketType === MarketTypes.SECONDARY;

  const areaValue = Array.isArray(area) ? sumArea : area;
  const imageSrc = isSecondaryMode
    ? attachment || image || iconBuildingDefault
    : planImage || iconBuildingDefault;

  return (
    <div className={clsx(styles.container, className)} onClick={onClick}>
      <div className={styles.image}>
        <img src={imageSrc} width={styles.imageSize} height={styles.imageSize} />
      </div>
      <div className={styles.description}>
        <div className={styles.housingEstate}>
          {isSecondaryMode ? buildingTitle : apartmentComplexesTitle}
        </div>

        {price !== undefined && (
          <div className={styles.prices}>
            <span
              className={clsx(
                styles.price,
                status?.key && status?.translation && styles.priceMiniFonts,
              )}
            >
              {toReadablePrice(price)}
            </span>
            {squarePrice !== undefined && (
              <span
                className={clsx(
                  styles.squarePrice,
                  status?.key && status?.translation && styles.squarePriceMiniFonts,
                )}
              >
                {toReadableSquarePrice(squarePrice)}
              </span>
            )}
          </div>
        )}

        <div className={styles.rooms}>{formatApartmentDesc(rooms, areaValue, floor)}</div>
        <>
          {isHide ? (
            <div className={styles.hideDescription}>
              <IconButton
                iconHeight={18}
                iconWidth={18}
                icon={eyeSlash}
                className={styles.hideIcon}
              />
              Скрытое
            </div>
          ) : null}
        </>
      </div>
      {leftIcon && <div className={clsx(styles.icon, styles.firstIcon)}>{leftIcon}</div>}
      {centreIcon && <div className={clsx(styles.icon, styles.secondIcon)}>{centreIcon}</div>}
      {icon && <div className={styles.icon}>{icon}</div>}
      {status?.key && status?.translation && (
        <Status status={status?.key} statusTitle={status?.translation} />
      )}
      {priceDirection && (
        <PriceDynamics className={styles.priceDynamics} variant={priceDirection} />
      )}
    </div>
  );
};

export const APARTMENT_LIST_ITEM_HEIGHT = parseInt(styles.containerHeight);

export default ApartmentListItem;
